import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";

import {DocumentUtils} from "../../Utils/DocumentUtils";
import {useChangePage} from "../../Hooks/NavigationHooks";

import {useContextBuilder} from "../../Hooks/ContextBuilderHooks";
import {useToolBuilder, useTools} from "../../Hooks/ToolBuilderHooks";

export const StreamBankToolRouter = props => {
    const [hasSession, setHasSession] = useState(true);
    const [toolContext, setToolContext] = useState();
    const displayTimeout = useSelector(state => state.loginState.displayTimeout);
    const breadcrumbs = useSelector(state => state.contextState.breadcrumbs);

    const params = useParams();
    const {tool, pProgId, cProgId, projId, conActId, sampleEventId} = params;

    const contextBuilder = useContextBuilder();
    const toolBuilder = useToolBuilder();
    const tools = useTools();
    const changePage = useChangePage();

    useEffect(() => {
        if (displayTimeout) {
            if (hasSession) {
                setHasSession(false);
            }
        } else {
            if (!hasSession) {
                setHasSession(true);
            }
        }
    }, [displayTimeout]);

    useEffect(() => {
        if(hasSession) {
            contextBuilder();
            const toolContext = toolBuilder();
            setToolContext(toolContext);
        }
    }, [tool, pProgId, cProgId, projId, conActId, sampleEventId, hasSession]);

    const defaultTool = tools?.find((x) => x.isDefault);
    
    useEffect(() => {
        if(toolContext?.isValid) {
            if(!toolContext.component) {
                const url = window.location.pathname;
                let segments = url.split("/");
                segments.splice(-1,1);
                changePage(segments.join("/") + "/" + defaultTool.key, false);
            }
        }
    }, [toolContext?.isValid, toolContext?.component, defaultTool]);

    if(toolContext && toolContext.isValid) {
        if(toolContext.component) {
            //Setup page title
            const tool = tools?.find(x => x.key == toolContext?.key);
            const node = breadcrumbs?.slice(-1)?.[0];
            if (node && tool) {
                const nodeShortTitle = node.shortTitle != null ? node.shortTitle : node.title;
                DocumentUtils.SetTitle(nodeShortTitle + " - " + tool.title + " - StreamBank®");
            } else if (tool) {
                DocumentUtils.SetTitle(tool.title + " - StreamBank®");
            }

            //render tool
            return <toolContext.component {...props} />;
        }
    }

    return null;
};
